module.exports = __webpack_public_path__ + "img/honer_bg.4459be74.jpg";